export enum ENodeType {
  richtext,
  video,
  exercise,
  certification,
}
